import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { ICourierModel } from '@apps-common/types/management/couriers'

export const QUERY_MANAGEMENT_GET_COURIERS = (name: string) => ['getCouriers', name]

export const getCouriers = async (name: string): Promise<ICourierModel[]> =>
  axios.get(`/management/courier/getcouriers?name=${name}`).then((res) => res.data?.data)

type QueryFnType = typeof getCouriers

type Props = {
  config?: QueryConfig<QueryFnType>
  name: string
}

export const useManagementGetCouriers = ({ config, name }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: QUERY_MANAGEMENT_GET_COURIERS(name),
    queryFn: () => getCouriers(name)
  })
